export default {
    intro: 'Look at the definition and choose the correct word!',
    th: {
        order: 'Number',
        meaning: 'Question',
        answer: 'Correct Answer',
        wrong: 'Wrong Answer',
        wrongChoices: 'Incorrect Choices',
        correctRate: 'Accuracy',
    },
    manySelectedWrongAnswer: 'Most Selected Incorrect Answer',
    teacher: {
        setting: {
            addQuestion: 'Add Question',
            searchCount: '{count} search results',
            defaultBadge: 'Default',
            otherCount: '+{count} more',
            waitHeader: 'Pending Words ({count})',
            clearAll: 'Clear All',
            registerCount: 'Add {count} to Activity',
            sameWordBadge: 'Same Headword',
            emptyMeaningBadge: 'No meaning',
            autoExtract: 'Auto-fill',
            delete: 'Delete',
            close: 'Close',
        },
        modal: {
            clearConfirm: {
                title: 'Clear all pending words?',
                message: 'All pending words will be removed. Continue?',
            },
            closeConfirm: {
                title: 'Discard your input?',
                message: 'Closing will discard all words in the pending list. Continue?',
            },
            questionDelete: {
                title: 'Delete this question?',
                // {word}: the headword of the question to be deleted. Warns that it will be permanently removed from the activity.
                message: "The question '{word}' will be removed from the activity. Continue?",
            },
            waitItemDelete: {
                title: 'Remove pending word?',
                // {word}: the pending word to be removed. Only removed from the queue; activity is not affected.
                message: "Remove '{word}' from the pending list. Continue?",
            },
            // {count}: number of words skipped due to duplicate dictionary entry
            duplicateNotice: '{count} word(s) already registered were not added.',
            // {count}: number of words skipped because they have no meaning
            skippedNotice: '{count} word(s) without meanings were not added.',
            // Confirmation when mixing empty-meaning words with valid ones
            mixedEmptyConfirm: {
                title: 'Register?',
                line1: '{empty} word(s) without meanings will not be added.',
                line2: 'Register only the remaining {valid} word(s)?',
            },
            // Notice when only empty-meaning words remain
            onlyEmptyNotice: {
                title: 'Cannot register',
                message: 'There are no words to register. Only words without meanings remain.',
            },
            registerFailed: 'Failed to add.',
        },
    },
};
